import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../core/services/auth-service/auth.service';
import { Subscription } from 'rxjs';
import {
  accessRightsList,
  IUserProfileDetails,
} from '../../../core/models/interface/login/i-login';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { NameAbbreviationPipe } from '../../pipes/name-abbreviation.pipe';
import { SidebarService } from '../../../core/services/sidebar/sidebar.service';
import { ApiResponse } from '../../../core/models/interface/api-response/api-response';
import { StatusCodeEnum } from '../../../core/models/enum/status-code-enum';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';
import { UserManagementService } from '../../../core/services/api/user-management/user-management.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterModule, CommonModule, NameAbbreviationPipe, FormsModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  private logOutSrv$: Subscription = new Subscription();
  private currentUser$: Subscription = new Subscription();
  isLogoutSuccessful: boolean = false;
  msgToast: string = '';
  userName: string = '';
  agencyName: string = '';
  roleName: string = '';
  permissionRoles: accessRightsList[] = [];

  constructor(
    private authSrv: AuthService,
    private toast: ToastrService,
    private sidebarSrv: SidebarService,
    private spinner: NgxSpinnerService,
    private userSrv: UserManagementService,
  ) {}

  ngOnInit() {
    this.getUserDetails();
  }

  getUserDetails() {
    this.currentUser$ = this.authSrv.currentUserLogin$.subscribe(
      (res: IUserProfileDetails | null) => {
        if (res && res.user_id) {
          this.userName = res.user_thai_name;
          this.agencyName = res.agency_name;

          this.permissionRoles = res.AllUserPermissionArray;
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.logOutSrv$) this.logOutSrv$.unsubscribe();
    if (this.currentUser$) this.currentUser$.unsubscribe();
  }

  get mainRole() {
    return this.permissionRoles.find((role) => role.is_main_access_rights);
  }

  get additionalRoles() {
    return this.permissionRoles.filter((role) => !role.is_main_access_rights);
  }

  handleSignOut() {
    this.spinner.show();
    this.authSrv
      .logout()
      .subscribe((res: ApiResponse) => {
        if (res.status_code === StatusCodeEnum.SUCCESS) {
          this.authSrv.removeAccessParam();
          setTimeout(() => {
            this.spinner.hide();
            this.goBackToIntranetWeb();
          }, 500);
        } else {
          this.spinner.hide();
          this.toast.error(res.message, 'ขออภัยเกิดข้อผิดพลาด', {
            timeOut: 2500,
            progressBar: true,
          });
        }
      });
  }

  goBackToIntranetWeb() {
    window.location.href = environment.url.apiIntranet;
  }

  openNotiFy() {
    this.sidebarSrv.toggleSidebar();
  }

  onToggleRole(role: any) {
    const payload = {
      access_rights_id: role.access_rights_id,
      is_active: role.is_active
    };

    this.spinner.show()
    this.userSrv.toggleSecondaryRoleStatus(payload)
      .subscribe((res: ApiResponse) => {
        if (res && res.status_code === StatusCodeEnum.SUCCESS) {
          window.location.reload();

        } else {
          this.spinner.hide();

          this.toast.error(res.description, 'ขออภัยเกิดข้อผิดพลาด', {
            timeOut: 2000,
            progressBar: true,
          });
        }
      });
  }

}
